import React, { Component } from 'react'

import { ORIGINALS } from 'client/bookmate/helpers/showcase-helpers'

import Spacer from 'client/shared/blocks/spacer'
import Showcase from 'client/bookmate/blocks/showcase'
import { TopicNavigationList } from 'client/bookmate/blocks/topic-navigation-list'
import ShowcaseSections from 'client/bookmate/blocks/showcase-sections'
import { Breadcrumbs } from 'client/shared/blocks/breadcrumbs'

import { State as AppState } from 'client/shared/reducers/app-reducer'
import { Dispatch } from 'shared/types/redux'
import {
  ShowcaseSection,
  Navigation,
  ContentType,
} from 'client/shared/types/showcase'
import { Trans } from '@lingui/react'

type Breadcrumb = {
  title: string
  link: string | boolean
}

type Props = {
  app: AppState
  language: string
  slug: string
  contentType: ContentType
  sections: ShowcaseSection[]
  navigation: Navigation[]
  dispatch: Dispatch
  breadcrumbs?: {
    hierarchy: Breadcrumb[]
    withLibrary?: boolean
    all: boolean
  }
  areLanguagesMatched: boolean
  getShowcasePath: (section: ShowcaseSection) => string
  userId: number
  sectionSlug?: string
  isKids?: boolean
}

class ShowcaseLayout extends Component<Props> {
  render(): JSX.Element {
    const { contentType } = this.props
    const isMixed = contentType === 'mixed'

    return (
      <div className="showcase-layout">
        <Showcase
          heading={
            this.props.breadcrumbs ? null : (
              <Trans
                id={
                  isMixed ? 'shared.library' : `miscellaneous.${contentType}s`
                }
              />
            )
          }
        >
          <Spacer size={32} />
          {this.renderBreadcrumbs()}
          {this.renderNavigation()}
          {this.renderSections()}
        </Showcase>
      </div>
    )
  }

  renderBreadcrumbs(): JSX.Element | undefined {
    const { breadcrumbs, app } = this.props

    return (
      breadcrumbs && (
        <>
          <Breadcrumbs breadcrumbs={breadcrumbs} query={app.storedQuery} />
          <Spacer size={32} />
        </>
      )
    )
  }

  renderNavigation(): JSX.Element | null {
    const { navigation, language, slug, app, contentType } = this.props

    if (!navigation || navigation.length === 0 || slug === ORIGINALS)
      return null

    return (
      <>
        <TopicNavigationList
          navigation={navigation}
          language={language}
          slug={slug}
          contentType={contentType}
          size={app.size}
          query={app.storedQuery}
        />
        <Spacer size={24} />
      </>
    )
  }

  renderSections(): JSX.Element {
    const {
      sections,
      app,
      dispatch,
      language,
      slug,
      areLanguagesMatched,
      getShowcasePath,
      userId,
      sectionSlug,
      isKids,
    } = this.props

    return (
      <ShowcaseSections
        isKids={isKids}
        sectionSlug={sectionSlug}
        sections={sections}
        app={app}
        dispatch={dispatch}
        language={language}
        slug={slug}
        areLanguagesMatched={areLanguagesMatched}
        getShowcasePath={getShowcasePath}
        userId={userId}
      />
    )
  }
}

export default ShowcaseLayout
